<template>
    <div class="checkout__address-wrapper">
        <div v-if="(!isAddressListEmpty && selectedAddress && addressType !== '2') || (addressType === '2' && deliveryAddressId !== -99)"
             class="checkout__address-complete">
            <template v-if="deliveryAddressId === -99 && addressType === '1'">
                <span class="d-inline-block" :class="{'mb-3': isBillingAddressVisible}">
                    {{ $translate("OD3dprimaV2::Template.billingAndShipping") }}
                </span>
            </template>
            <template v-else>
                <template v-if="addressType === '1'">
                    {{ $translate("OD3dprimaV2::Template.billingAddress") }}
                </template>
                <template v-else-if="addressType === '2' && deliveryAddressId !== -99">
                    {{ $translate("OD3dprimaV2::Template.shippingAddress") }}
                </template>
            </template>
        </div>
        <div class="cmp cmp-address-list checkout__address-summary"
             v-if="!showAddressForm">
            <div class="dropdown items">
                <div :id="'addressMultiSelect' + _uid"
                     :class="{
                         'items items-empty': isAddressListEmpty && (addressType === '2' && addressList.length === 1),
                         'is-loading disabled': isBasketLoading || isCheckoutReadonly
                     }">
                    <div v-if="!isAddressListEmpty && selectedAddress && selectedAddress.id !== -99"
                         class="item-inner"
                         :class="{'error': showError}">
                        <span class="item-content">
                            <address-header-checkout :address="selectedAddress" :class="paddingClasses" :style="paddingInlineStyles"></address-header-checkout>
                        </span>
                    </div>
                </div>

                <div v-if="addressType === '1'" class="btn btn-secondary btn-secondary--no-shadow btn-block card"
                     :class="{'mt-5': this.isBillingAddressVisible && this.isAddAddressEnabled}"
                     @click="showEditAddress(selectedAddress)">
                    {{ $translate("OD3dprimaV2::Template.addressChange") }}
                </div>
                <div v-else class="btn btn-secondary btn-secondary--no-shadow btn-block"
                     :class="{
                        'dropdown-toggle card': isAddAddressEnabled,
                        'd-none': !isShippingVisible,
                        'mt-5': this.isBillingAddressVisible && this.isAddAddressEnabled
                     }"
                     @click="onDropdownClicked($event)"
                     data-toggle="dropdown"
                     aria-haspopup="true"
                     aria-expanded="false"
                     data-boundary="window"
                     data-flip="false">
                    {{
                        deliveryAddressId === -99 & addressType === '2'
                            ? $translate("OD3dprimaV2::Template.addressDifferent")
                            : $translate("OD3dprimaV2::Template.addressChange")
                    }}
                </div>

                <div class="dropdown-menu"
                     :aria-labelledby="'addressMultiSelect' + _uid"
                     v-if="isAddAddressEnabled && addressType !== '1'"
                     ref="addressDropdown">
                    <ul>
                        <li class="item" v-for="(address, index) in addressList">
                            <input type="radio"
                                   :name="'shippingAddress' + _uid"
                                   :id="'addressSelectItem' + _uid + address.id"
                                   :value="address.id"
                                   :checked="selectedAddress && selectedAddress.id === address.id"
                                   @change="onAddressChanged(address)">
                            <label :for="'addressSelectItem' + _uid + address.id" class="item-inner">
                                <span v-if="address.id == -99">
                                    <span class="text-muted small font-italic pt-3">
                                        {{ $translate("Ceres::Template.addressSameAsInvoice") }}
                                    </span>
                                </span>
                                <span v-else class="item-content small">
                                    <address-header-checkout :address="address" :class="paddingClasses" :style="paddingInlineStyles"></address-header-checkout>
                                </span>
                                <div class="item-controls" v-if="address.id != -99">
                                    <span class="item-edit">
                                        <button v-tooltip
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                :title="$translate('Ceres::Template.addressEdit')"
                                                class="btn btn-primary btn-appearance"
                                                @click.prevent="showEditAddress(address)">
                                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        </button>
                                    </span>
                                    <span class="item-remove">
                                        <button v-tooltip
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                :title="$translate('Ceres::Template.addressDelete')"
                                                class="btn btn-danger"
                                                @click.prevent="showDeleteModal(address)">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </span>
                                </div>
                            </label>
                        </li>
                    </ul>
                    <div v-if="addressType === '2'" class="text-center">
                        <button class="btn btn-primary btn-appearance"
                                @click.prevent="showAddAddress()"
                                :disabled="isBasketLoading || isCheckoutReadonly">
                            {{ $translate("Ceres::Template.addressAddAddress") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <fieldset v-else ref="addressModal">
            <h5 class="checkout__column-sub-title mt-3" v-if="addressType === '2'">
                {{ $translate("OD3dprimaV2::Template.shippingAddress") }}
            </h5>
            <create-update-address-checkout
                    :address-data="addressToEdit"
                    :modal-type="modalType"
                    :address-type="addressType"
                    @input="setAddressToEditField($event)"
                    :optional-address-fields="optionalAddressFields"
                    :required-address-fields="requiredAddressFields"
                    :default-salutation="defaultSalutation"
                    :is-billing-address-visible="isBillingAddressVisible"
                    :is-delivery-address-visible="isDeliveryAddressVisible"
                    @saved="closeAddress">
                <template #custom-address-fields>
                    <slot name="custom-address-fields"></slot>
                </template>
            </create-update-address-checkout>
        </fieldset>

        <div ref="deleteModal">
            <div class="modal fade" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">
                                {{ $translate('Ceres::Template.addressShippingAddressDelete') }}
                            </h4>
                            <button type="button" class="close" @click="closeDeleteModal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <fieldset>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="modal-address">
                                            <strong v-if="addressToDelete.name1 && addressToDelete.name1.length > 0">
                                                {{addressToDelete.name1}}
                                            </strong>
                                            <strong v-if="!addressToDelete.name1 || addressToDelete.name1.length == 0">
                                                {{addressToDelete | optionType(11)}} {{addressToDelete.name2}} {{addressToDelete.name3}}
                                            </strong>
                                            <span v-else>
                                                {{selectedAddress | optionType(11)}} {{addressToDelete.name2}} {{addressToDelete.name3}}
                                            </span>
                                            <span>
                                                {{addressToDelete.name4}}
                                            </span>
                                            <span>
                                                {{addressToDelete.address1}} {{addressToDelete.address2}}
                                            </span>
                                            <span>
                                                <template v-if="addressToDelete.address1 === 'PACKSTATION' || addressToDelete.address1 === 'POSTFILIALE'">
                                                    {{ $translate("Ceres::Template.addressPostNummer") }}
                                                    {{addressToDelete | optionType(6)}}
                                                </template>
                                                {{ addressToDelete.address3 }}
                                            </span>
                                            <span>
                                                {{addressToDelete.postalCode}} {{addressToDelete.town}}
                                            </span>
                                            <span>
                                                {{getCountryName(addressToDelete.countryId)}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-medium mr-2 btn-outline-primary" @click="closeDeleteModal">
                                <span>{{ $translate("Ceres::Template.addressCancel") }}</span>
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-primary btn-appearance btn-medium" :disabled="deleteModalWaiting" @click="deleteAddress">
                                <span>{{ $translate("Ceres::Template.addressDelete") }}</span>
                                <icon icon="trash" :loading="deleteModalWaiting"></icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isDefined, isNullOrUndefined} from 'ceres/app/helper/utils';
import ValidationService from 'ceres/app/services/ValidationService';
import {mapState} from 'vuex';
import CreateUpdateAddressCheckout from './CreateUpdateAddress.vue';
import AddressHeaderCheckout from './AddressHeader.vue';

const ApiService = require('ceres/app/services/ApiService');
const ModalService = require('ceres/app/services/ModalService');

export default {

    components: {
        CreateUpdateAddressCheckout,
        AddressHeaderCheckout
    },

    props: {
        addressType: {
            type: String,
            required: true
        },
        showError: Boolean,
        optionalAddressFields: {
            type: Object,
            default: () => {
                return {
                    de: [],
                    gb: []
                };
            }
        },
        requiredAddressFields: {
            type: Object,
            default: () => {
                return {};
            }
        },
        defaultSalutation: {
            type: String,
            default: 'male'
        },
        paddingClasses: {
            type: String,
            default: null
        },
        paddingInlineStyles: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            modalType: 'create',
            addressToEdit: {
                gender    : this.defaultSalutation,
                countryId : this.shippingCountryId
            },
            addressToDelete           : {},
            deleteModal               : null,
            deleteModalWaiting        : false,
            addressOptionTypeFieldMap : {
                1: 'vatNumber',
                4: 'telephone',
                6: 'postNumber',
                9: 'birthday',
                11: 'title',
                12: 'contactPerson'
            },
            showAddress              : null,
            isBillingAddressVisible  : true,
            isDeliveryAddressVisible : false,
            isShopbuilder            : App.isShopBuilder
        };
    },

    computed: {
        selectedAddress() {
            return this.$store.getters.getSelectedAddress(this.addressType);
        },

        addressList() {
            return this.$store.getters.getAddressList(this.addressType);
        },

        shippingCountryId() {
            return this.$store.state.localization.shippingCountryId;
        },

        isAddAddressEnabled() {
            return this.$store.getters.isLoggedIn
        },

        isAddressListEmpty() {
            return !(this.addressList && this.addressList.length > 0);
        },

        isSalutationEnabled() {
            const countryId = parseInt(this.addressToEdit.countryId) || 1;
            const addressKey = parseInt(this.addressType) === 1 ? 'billing_address' : 'delivery_address';
            const countryKey = countryId === 12 ? 'gb' : 'de';

            return this.optionalAddressFields[countryKey].includes(`${addressKey}.salutation`);
        },

        showAddressForm() {

            if(this.showAddress !== null) {
                return this.showAddress;
            }

            return !(this.addressList && this.addressList.length > 0);
        },

        isShippingVisible() {
            return this.addressType === '2' && (!this.isBillingAddressVisible || this.isAddAddressEnabled)
        },

        ...mapState({
            countryList: state => state.localization.shippingCountries,
            isBasketLoading: state => state.basket.isBasketLoading,
            isCheckoutReadonly: state => state.checkout.readOnly,
            billingAddressId: state => state.address.billingAddressId,
            deliveryAddressId: state => state.address.deliveryAddressId
        })
    },

    /**
     *  Check whether the address list is not empty and select the address with the matching ID
     */
    created() {

        this.addEventListener();

        this.isBillingAddressVisible = isNullOrUndefined(this.billingAddressId);

        if(this.isShopbuilder) {
            this.showAddress              = true;
            this.isDeliveryAddressVisible = true;
            this.isBillingAddressVisible  = true;
        }
    },

    /**
     * Select the address modal
     */
    mounted() {
        this.$nextTick(() => {

            this.deleteModal = ModalService.findModal(this.$refs.deleteModal);

            this.enableCheckoutSteps();
        });
    },

    methods: {
        /**
         * Add the event listener
         */
        addEventListener() {
            ApiService.listen('AfterAccountContactLogout', () => {
                this.$store.commit('resetAddress', this.addressType);
            });
            document.addEventListener('toggleBillingAddress', (event) => {
                this.isBillingAddressVisible = event.detail
            });
            document.addEventListener('toggleDeliveryAddress', () => {

                if(this.addressType === '1') {
                    this.isDeliveryAddressVisible = !this.isDeliveryAddressVisible;
                }

                if(this.addressType === '2') {
                    this.showAddress = !this.showAddress
                }
            })
        },

        /**
         * Update the selected address
         * @param address
         */
        onAddressChanged(address) {
            this.$emit('address-changed', address);
        },

        /**
         * Show the add modal
         */
        showAddAddress() {

            this.modalType = 'create';

            if (this.isSalutationEnabled) {
                this.addressToEdit = {
                    gender            : this.defaultSalutation,
                    countryId         : this.shippingCountryId,
                    showPickupStation : false
                };
            }else {
                this.addressToEdit = {countryId: this.shippingCountryId};
            }

            if (this.modalType === 'create') {
                ValidationService.unmarkAllFields($(this.$refs.addressModal));
            }

            this.showAddress = true;
            this.dispatchToggleBilling(true);

        },

        /**
         * Show the edit modal
         * @param address
         */
        showEditAddress(address) {

            this.modalType     = 'update';
            this.addressToEdit = this.getAddressToEdit(address);

            if (isDefined(this.addressToEdit.address1) && (this.addressToEdit.address1 === 'PACKSTATION' || this.addressToEdit.address1 === 'POSTFILIALE') && this.$store.getters.isParcelOrOfficeAvailable) {
                this.addressToEdit.showPickupStation = true;
            }

            ValidationService.unmarkAllFields($(this.$refs.addressModal));

            this.showAddress = true;
            this.dispatchToggleBilling(true);
        },

        getAddressToEdit(address) {

            // Creates a tmp address to prevent unwanted two-way binding
            const addressToEdit = JSON.parse(JSON.stringify(address));

            if (addressToEdit.options) {
                for (const option of addressToEdit.options) {

                    const optionName = this.addressOptionTypeFieldMap[option.typeId];

                    addressToEdit[optionName] = option.value || null;
                }
            }

            return addressToEdit;
        },

        /**
         * Close the current create/update address address
         */
        closeAddress() {
            this.showAddress = false;
        },

        /**
         * Show the delete modal
         * @param address
         */
        showDeleteModal(address) {

            this.modalType       = 'delete';
            this.addressToDelete = address;

            this.deleteModal.show();
        },

        /**
         * Delete the address selected before
         */
        deleteAddress() {
            this.deleteModalWaiting = true;

            this.$store.dispatch('deleteAddress', {address: this.addressToDelete, addressType: this.addressType})
                .then(
                    response => {
                        this.closeDeleteModal();
                        this.deleteModalWaiting = false;
                    },
                    error => {
                        this.deleteModalWaiting = false;
                    }
                );
        },

        /**
         * Close the current delete address modal
         */
        closeDeleteModal() {
            this.deleteModal.hide();
        },

        /**
         * @param countryId
         * @returns string
         */
        getCountryName(countryId) {
            return this.$store.getters.getCountryName(countryId);
        },

        setAddressToEditField({field, value}) {
            this.addressToEdit[field] = value;
            this.addressToEdit        = Object.assign({}, this.addressToEdit);
        },

        onDropdownClicked(event) {

            if (!this.isAddAddressEnabled) {

                event.preventDefault();
                event.stopPropagation();

                if(this.addressType === '1') {
                    this.modalType               = 'update';
                    this.addressToEdit           = this.getAddressToEdit(this.addressList[0]);
                    this.showAddress             = true;

                    this.dispatchToggleBilling(true);
                }

                if(this.addressType === '2') {
                    document.dispatchEvent(new CustomEvent('toggleDeliveryAddress'));
                }
            }
        },

        dispatchToggleBilling(value) {
            if(this.addressType === '1') {
                document.dispatchEvent(new CustomEvent('toggleBillingAddress', {
                    detail: value
                }));
            }
        },

        enableCheckoutSteps() {

            if(this.addressType === '1' && !isNullOrUndefined(this.billingAddressId)) {

                let checkoutElement = document.querySelector('.checkout__wrapper');

                if(checkoutElement) {
                    checkoutElement.classList.add('checkout__address-step-complete');
                }
            }
        }
    },

    filters: {
        optionType(selectedAddress, typeId) {
            if (selectedAddress && selectedAddress.options) {
                for (const optionType of selectedAddress.options) {
                    if (optionType.typeId === typeId) {
                        return optionType.value;
                    }
                }
            }

            return '';
        }
    },

    watch: {
        isSalutationEnabled(newVal) {
            if (!newVal) {
                delete this.addressToEdit.gender;
            }
        },
        billingAddressId() {
            this.enableCheckoutSteps();
        }
    }
};
</script>
